var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkUrlRss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.2187C10.4295 13.7928 10.9774 14.2679 11.6066 14.6117C12.2357 14.9554 12.9315 15.1598 13.6467 15.211C14.3618 15.2623 15.0796 15.1591 15.7513 14.9085C16.4231 14.6579 17.0331 14.2658 17.54 13.7587L20.54 10.7587C21.4508 9.8157 21.9548 8.55269 21.9434 7.24171C21.932 5.93073 21.4061 4.67666 20.4791 3.74962C19.5521 2.82258 18.298 2.29674 16.987 2.28535C15.676 2.27395 14.413 2.77793 13.47 3.68872L11.75 5.39872",
    stroke: "#242946",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 11.219C13.5707 10.6448 13.0228 10.1698 12.3936 9.82604C11.7645 9.48228 11.0687 9.27786 10.3535 9.22664C9.63841 9.17542 8.92061 9.27861 8.24885 9.52919C7.5771 9.77978 6.96709 10.1719 6.4602 10.679L3.4602 13.679C2.54941 14.622 2.04544 15.885 2.05683 17.196C2.06822 18.507 2.59407 19.761 3.52111 20.6881C4.44815 21.6151 5.70221 22.141 7.01319 22.1523C8.32418 22.1637 9.58719 21.6598 10.5302 20.749L12.2402 19.039",
    stroke: "#242946",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkUrlRss);
export default __webpack_public_path__ + "static/media/linkUrlRss.495b5be186fb5a8d57cc6c4b6198d32a.svg";
export { ForwardRef as ReactComponent };